import type {RefObject} from 'react';
import {createContext, useContext} from 'react';
import {useContainerQuery} from '@Hooks/useContainerQuery';
import type {AiChatSizeState} from '@AiChat/hooks/useAiChatSize.types';
import {AI_CHAT_SIZE_ORDER, AI_CHAT_SIZE_QUERY, AiChatSize} from '@AiChat/hooks/useAiChatSize.types';

export const aiChatSizeContext = createContext<AiChatSize>(AiChatSize.LARGE);

export function useMeasuredAiChatSize(ref: RefObject<HTMLElement | null>): AiChatSize | null {
  const matches = useContainerQuery(ref, AI_CHAT_SIZE_QUERY);

  if (matches[AiChatSize.SMALL]) {
    return AiChatSize.SMALL;
  }

  if (matches[AiChatSize.MEDIUM]) {
    return AiChatSize.MEDIUM;
  }

  if (matches[AiChatSize.LARGE]) {
    return AiChatSize.LARGE;
  }

  return null;
}

export function useAiChatSize(): AiChatSizeState {
  const size = useContext(aiChatSizeContext);

  return {
    size,
    isSmall: size === AiChatSize.SMALL,
    isMedium: size === AiChatSize.MEDIUM,
    isLarge: size === AiChatSize.LARGE,
  };
}

export function isAtLeastAiChatSize(actual: AiChatSize, minimum: AiChatSize): boolean {
  return AI_CHAT_SIZE_ORDER.indexOf(actual) >= AI_CHAT_SIZE_ORDER.indexOf(minimum);
}
